import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { IconTextModule } from '@app/components/iconText/iconText.module';
import { BlockHtmlComponent } from '@app/components/blocks/block-html/block-html.component';
import { SafeHtmlPipeModule } from '@shared/pipes/safeHtml/safeHtml.pipe.module';

@NgModule({
  imports: [CommonModule, SharedModule, IconTextModule, SafeHtmlPipeModule],
  declarations: [BlockHtmlComponent],
  exports: [BlockHtmlComponent],
})
export class BlockHtmlModule {}
